import RealEstate from "../assets/icons/agreement.png";
import Agriculture from "../assets/icons/agriculture.png";
import ConstructionWorker from "../assets/icons/construction-worker.png";
import IndustrialCleaning from "../assets/icons/industrial-cleaning.png";
import Gastronomy from "../assets/icons/gastronomy.png";
import Package from "../assets/icons/package.png";
import HealthCare from "../assets/icons/healthcare.png";
import Other from "../assets/icons/menu.png";
import Retail from "../assets/icons/shopping-store.png";

export const candidateType = [
  { label: "Students (Holiday work, Internship)", value: "STUDENTS" },
  { label: "Seasonal workers", value: "SEASONAL_WORKERS" },
  { label: "Long-term employees", value: "LONG_TERM_EMPLOYEES" },
];

export const candidateRegion = [
  { label: "Only EU", value: "ONLY_EU" },
  { label: "EU + Third Countries", value: "EU_THIRD_COUNTRIES" },
  { label: "Only Third Countries", value: "ONLY_THIRD_COUNTRIES" },
];

export const employmentTypes = [
  { label: "Full-time", value: "FULL_TIME" },
  { label: "Part-time", value: "PART_TIME" },
  { label: "Mini-job", value: "MINI_JOB" },
  { label: "Student job", value: "STUDENT_JOB" },
  { label: "Internship", value: "INTERNSHIP" },
  { label: "Seasonal", value: "SEASONAL" },
];

export const urgencyLevel = [
  { label: "ASAP", value: "ASAP" },
  { label: "Next Month", value: "NEXT_MONTH" },
  { label: "Flexible", value: "FLEXIBLE" },
];

export const employmentDuration = [
  { label: "< 3 months", value: "LESS_THAN_3_MONTHS" },
  { label: "3–6 months", value: "THREE_TO_SIX_MONTHS" },
  { label: "6–12 months", value: "SIX_TO_TWELVE_MONTHS" },
  { label: "12+ months", value: "TWELVE_PLUS_MONTHS" },
];

export const shiftType = [
  { label: "Fixed shift", value: "FIXED_SHIFT" },
  { label: "Rotating", value: "ROTATING" },
  { label: "Night shifts", value: "NIGHT_SHIFTS" },
];

export const jobType = [
  { label: "Students (Holiday work, Internship)", value: "STUDENTS" },
  { label: "Seasonal workers", value: "SEASONAL_WORKERS" },
  { label: "Long-term employees", value: "LONG_TERM_EMPLOYEES" },
];

export const preferedIndustry = [
  {
    value: "LOGISTICS",
    label: "Logistics",
    icon: Package,
  },
  {
    value: "GASTRONOMY",
    label: "Gastronomy",
    icon: Gastronomy,
  },
  {
    value: "RETAIL",
    label: "Retail",
    icon: Retail,
  },
  {
    value: "OFFICE",
    label: "Office Jobs",
    icon: RealEstate,
  },
  {
    value: "AGRICULTURE",
    label: "Agriculture",
    icon: Agriculture,
  },
  {
    value: "HEALTHCARE",
    label: "Healthcare",
    icon: HealthCare,
  },
  {
    value: "CONSTRUCTION",
    label: "Construction",
    icon: ConstructionWorker,
  },
  {
    value: "CLEANING",
    label: "Cleaning",
    icon: IndustrialCleaning,
  },
  {
    value: "WAREHOUSE_PRODUCTION",
    label: "Warehouse / Production",
    icon: Other,
  },
];

export const hearAboutUsOptions = [
  { label: "Referral from Friend", value: "REFERRAL_FROM_FRIEND" },
  { label: "Social Media", value: "SOCIAL_MEDIA" },
  { label: "Events", value: "EVENTS" },
  { label: "Printed Media", value: "PRINTED_MEDIA" },
  { label: "Search Engine", value: "SEARCH_ENGINE" },
  { label: "LinkedIn", value: "LINKEDIN" },
  { label: "Instagram", value: "INSTAGRAM" },
  { label: "Facebook", value: "FACEBOOK" },
  { label: "Other", value: "OTHER" },
];

export const typeOfJob = [
  { label: "Public", value: false },
  { label: "Private", value: true },
];
